"use client";

import { IconCheckOutline18, IconCopyOutline18 } from "nucleo-ui-outline-18";
import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

interface Props {
  curlCommand: string;
}

export function CopyCurlButton({ curlCommand }: Props) {
  const { isCopied, copyToClipboard } = useCopyToClipboard(1500);

  return (
    <Button variant="white" size="sm" onClick={() => copyToClipboard(curlCommand)} aria-label="Copy curl command">
      <span className="flex items-center gap-2 text-xs">
        {isCopied ? <IconCheckOutline18 className="h-3 w-3" /> : <IconCopyOutline18 className="h-3 w-3" />}
        {isCopied ? "Copied" : "Copy curl"}
      </span>
    </Button>
  );
}
